
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/cartpop.css";
import "../styles/cartpop.css";
import Loader from "../components/loader/loader.jsx";
import FooterBar from "../components/footrt/FooterBar.jsx";
import { CustomerProductApi } from "api/customer-product.api";
import CustomerProductListDisplay from "components/weddigservice/CustomerProductListDisplay";
import { CUSTOMER_PRODUCT_POST_TYPE_MAP } from "utils/constants";

function CustomerProductListPage() {
  const { postType } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (isInitialLoad) {
      window.scrollTo(0, 0);
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  async function fetchProducts() {
    setLoading(true);
    try {
      const productListResponse = await CustomerProductApi.getCustomerProducts({
        postType,
      });
      setProducts(productListResponse.customerProducts);
    } catch (error) {
      console.log("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  }

  // Load cart from localStorage on component mount
  useEffect(() => {
    if(postType){
      fetchProducts();
    }
  }, [postType]);


  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
          <> 
            <CustomerProductListDisplay
              products={products}
              postType={postType}
              displayTitle={CUSTOMER_PRODUCT_POST_TYPE_MAP.TITLE[postType]}
              displaySubTitle={CUSTOMER_PRODUCT_POST_TYPE_MAP.SUB_TITLE[postType]}
              isLoading={loading}
              isRepairPage={true}
            />
          </>
      )}
      <FooterBar />
    </>
  );
}

export default CustomerProductListPage;